import { Link } from "react-router";
import Phone from "../../svgs/Phone";

const Header = () => {
    return <div className="site-header">
        <div className="logo-container">
            <Link to="/" style={{   display: 'contents' }}>
                <img src="/logo512.png" alt="NZ Roof Painting Logo" className="logo" />
                <span>Exterior Painting Services</span>
            </Link>
        </div>


        <a className="phone-link" href="tel:0275184992"><Phone /><span className="phone">027 518 4992</span></a>
    </div>
}

export default Header;

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return <div className="site-footer">
        <span>NZ Roof Painting © {currentYear}</span>
    </div>
}

export { Footer };